import { useState } from 'react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import { forensicsApiRef } from '../api';
import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import { getCompoundEntityRef } from '@backstage/catalog-model';

export enum ErrorType {
    CONNECTION_ERROR,
    NOT_FOUND,
}

/**
 * Hook to expose the list of forensic items for an entity.
 */
export function useForensicItems() {
    const { entity } = useEntity();
    const entityName = getCompoundEntityRef(entity);
    const api = useApi(forensicsApiRef);
    const errorApi = useApi(errorApiRef);

    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [error, setError] = useState<{
        message: string;
        errorType: ErrorType;
    }>();

    const {
        loading,
        value: items,
        retry,
    } = useAsyncRetry(async () => {
        try {
            const teamspace: string = entity.spec?.system as string;
            const app: string = entity.metadata.title || entity.metadata.name;
            const type: string = entity.spec?.type === "perftest" ? "jobs" : "apps"
            const list = await api.listForensicsItems({
                teamspace: teamspace.substring('system:'.length),
                app,
                type,
            });

            setTotal(list.length);

            return list;
        } catch (e) {
            //      const errorType = e.notFound
            //        ? ErrorType.NOT_FOUND
            //        : ErrorType.CONNECTION_ERROR;
            //      setError({ message: e.message, errorType });
            throw e;
        }
    }, [api, errorApi, entity]);

    return [
        {
            page,
            pageSize,
            loading,
            items,
            total,
            error,
        },
        {
            setPage,
            setPageSize,
            retry, // fetch data again
        },
    ] as const;
}
